import {Virtuoso} from 'react-virtuoso'
import styled, {css} from 'styled-components'

export const StyledContainerMobileTable = styled(Virtuoso)`
    ${({theme}) => css`
        overflow-y: scroll !important;

        &::-webkit-scrollbar {
            width: 2px;
            background-color: ${theme.palette.neutral[50]};
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${theme.palette.neutral[300]};
            border-radius: 3px;

            &:hover {
                background-color: ${theme.palette.neutral[400]};
            }
        }
    `}
`
